import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  button: {
    display: "flex",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
      textDecorationColor: "gray",
    },
  },
  label: {
    color: "gray",
    marginLeft: "8px",
    fontSize: "0.8125rem",
    position: "relative",
    textTransform: "none",
  },
}))

export default styles
